module.exports = __webpack_public_path__ + "static/media/interface.778c73d7.png";